import { useQuery, useQueryClient, useMutation } from "@tanstack/react-query";
import { success } from "../global/ToastAlert";
import { useGetVendorId } from "../../hooks/global/User";
import api from '../../services/api';

const empty = {
    id:"",
    source_id: "",
    name:{},
    tags:[],
    status:"OK",
    code:"",
    description:"",
    img_url:"",
    vendor_id:"",
    group_id:""
}

export const useGetEmptyProduct = () => {
    return {...empty};
}

export const useGetProducts = (moduleId) => {
    const vendorId = useGetVendorId();
    const fetchData = async () => {
        const { data } = ( moduleId ) ? await api.get(`${process.env.REACT_APP_API_URL}/modules/${moduleId}/products/?vendorId=${vendorId}`) : {data:[]}
        return data;
    };
    return useQuery({ queryKey: ['products', moduleId], queryFn: fetchData, enabled: true });
};

export const useGetProduct = ( productsId ) => {
    const vendorId = useGetVendorId();
    const fetchData = async () => {
        const { data } = ( productsId ) ? await api.get(`${process.env.REACT_APP_API_URL}/product/${productsId}/?vendorId=${vendorId}`) : {data: {...empty}}
        return data;
    }
    return useQuery({ queryKey: ['product', productsId], queryFn: fetchData, enabled: false });
};

export const useGetProductBySource = ( product ) => {
    const vendorId = useGetVendorId();
    const fetchData = async () => {
        const { data } = ( product ) ? await api.get(`${process.env.REACT_APP_API_URL}/product/source/${product}/?vendorId=${vendorId}`) : {data: {...empty}}
        return data;
    }
    return useQuery({ queryKey: ['product', product], queryFn: fetchData, enabled: false });
};

export const useUpdateProducts = (productsId, moduleId) => {
    const vendorId = useGetVendorId();
    const queryClient = useQueryClient();
    const updateData = async ({data:updateData, message=null}) => {
        const { data } = await api.post(`${process.env.REACT_APP_API_URL}/product/${productsId}/?vendorId=${vendorId}`, updateData)
        queryClient.invalidateQueries(['products', moduleId]);
        if(!data?.error) success(message);
        return data;
    };
    return useMutation(updateData);
};

export const useInsertProducts = ( moduleId ) => {
    const queryClient = useQueryClient();
    const vendorId = useGetVendorId();
    const insertData = async ({ data:insertData, message=null }) => {
        const { data } = await api.post(`${process.env.REACT_APP_API_URL}/modules/${moduleId}/product/?vendorId=${vendorId}`, insertData);
        queryClient.invalidateQueries(['products', moduleId]);
        if(!data?.error) success(message);
        return data;
    };

    return useMutation(insertData);
};

/*

export const useInsertProducts = () => {
    const queryClient = useQueryClient();

    const insertData = async () => {
        const { data } = await api.post(`${process.env.REACT_APP_API_URL}/question/?vendorId=${vendorId}`, insertData);
        queryClient.invalidateQueries(['question', data.id]);
        return data;
    };

    return useMutation(insertData, {
        onSuccess: (data) => {}
    });
};

export const useDeleteProducts = () => {
    const queryClient = useQueryClient();

    const deleteQuestion = async (questionId) => {
        await api.delete(`${process.env.REACT_APP_API_URL}/question/${questionId}`);
        queryClient.invalidateQueries(['question', questionId]);
    };

    return useMutation(deleteQuestion);
};*/
